import React from 'react';

import '../../../static/scss/components/infoBox.scss';

type Props = {
  children: any,
  color?: 'green' | 'blue' | 'transparent' | 'yellow' | 'red' | 'nhs-blue',
  icon?: any,
  border?: boolean,
  className?: string,
  arrow?: ?'top' | 'bottom' | 'left' | 'right'
};

const baseClass = 'c-info-box';

const InfoBox = ({
  children,
  color = 'green',
  icon = false,
  border = false,
  arrow = null,
  className = ''
}: Props) => (
  <div
    className={`${baseClass} ${baseClass}--${color} ${className} ${
      icon ? `${baseClass}--with-icon` : ''
    } ${border ? `${baseClass}--border` : ''} ${
      arrow ? `${baseClass}--arrow ${baseClass}--arrow--${arrow}` : ''
    }`}
  >
    {icon && <span className={`${baseClass}--icon`}>{icon}</span>}
    <span className={`${baseClass}--content`}>{children}</span>
  </div>
);

export default InfoBox;
